export const taskInfoFragment = `
id
name
description
image
icon
`;

export const taskLibraryInfoFragment = `
id
name
description
image
icon
`;
